import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { Box, IconButton } from '@mui/material';
import { RemissionAsset } from './RemissionUi';

type Props = {
  asset: RemissionAsset;
  onOpen: () => void;
};

export default function RenderRemissionAsset({ asset, onOpen }: Props) {
  switch (asset.kind) {
    case 'pdfSavedAsset':
      return (
        <IconButton
          sx={{ width: '100%', height: '100%', p: '0px' }}
          onClick={onOpen}
          disableRipple
        >
          <iframe
            src={asset.url}
            style={{
              width: '100%',
              height: '100%',
              paddingRight: '48px',
            }}
            loading="lazy"
          />
        </IconButton>
      );

    case 'imageSavedAsset':
      return (
        <IconButton
          sx={{ width: '100%', height: '100%', p: '0px' }}
          onClick={onOpen}
          disableRipple
        >
          <Box
            component="img"
            src={asset.url}
            sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </IconButton>
      );

    case 'imagePendingToSaveAsset':
      return (
        <Box
          component="img"
          src={asset.data}
          sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      );

    case 'pdfPendingToSaveAsset':
      return (
        <PictureAsPdfOutlinedIcon
          sx={{ fontSize: '120px', color: 'text.secondary' }}
        />
      );
  }
}
